import { changeStepSelectOperator as changeStepSelectOperatorDiagram, selectStepFilterGridData } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepSelectOperatorProps = {
    mode?: string;
}

export const changeStepSelectOperator = ({
    mode,
}: StepSelectOperatorProps) => {
    changeStepSelectOperatorDiagram({ mode });
    selectStepFilterGridData('');
};
